import { createFeatureSelector, createSelector } from "@ngrx/store";
import { MessagingState } from "./messaging.reducer";


export const selectMessagingState = createFeatureSelector<MessagingState>('messaging');
export const selectActiveChannelId = createSelector(selectMessagingState, (state: MessagingState) => state.activeChannelId);
export const selectInitialChannelMessageId = createSelector(selectMessagingState, (state: MessagingState) => state.initialChannelMessageId);
export const selectChannelIdToChannelMap = createSelector(selectMessagingState, (state: MessagingState) => state.channelIdToChannelMap);
export const selectChannelFilter = createSelector(selectMessagingState, (state: MessagingState) => state.channelFilter);
export const selectTopicValidationKeyMap = createSelector(selectMessagingState, (state: MessagingState) => state.topicValidationKeyMap);

export const selectChannels = createSelector(
    selectMessagingState,
    (state: MessagingState) => {
        return state.channelIds.map((channelId) => state.channelIdToChannelMap[channelId]);
    });

export const selectActiveChannelChangeRawData = createSelector(
    selectActiveChannelId,
    selectInitialChannelMessageId,
    (activeChannelId: string, initialChannelMessageId: string) => {
        return {
            channelId: activeChannelId,
            initialChannelMessageId: initialChannelMessageId
        }
    }
)

export const selectActiveChannel = createSelector(
    selectMessagingState,
    (state: MessagingState) => {
        return state.channelIdToChannelMap[state.activeChannelId];
    }
)

export const selectActiveChannelMessages = createSelector(
    selectMessagingState,
    (state: MessagingState) => {
        return state.activeChannelMessages;
    }
)
